
import  { useState, useEffect } from 'react';
import { Table, Tabs, Button, Spin, Modal, message } from 'antd';
import { EyeOutlined, EditOutlined, SyncOutlined, DeleteOutlined } from '@ant-design/icons';

import PatientIntakeForm from './forms/PatientIntakeForm';
import ClinicalNotePatientForm from './forms/ClinicalNotePatientForm';
import axios from 'axios';
import ClinicalNotesModal from '../ClinicalNote/ClinicalNoteOutput/clinicalNotePopup';
import { useNavigate } from 'react-router-dom';

const { confirm } = Modal;


const { TabPane } = Tabs;




export default function MedicalDocumentation() {
  const navigate =useNavigate()
  const [openPatientIntakeForm, setOpenPatientIntakeForm] = useState(false);

  const [openPatientClinicalForm, setOpenPatientClinicalForm] = useState(false);
  const [deleted,setDeleted]=useState(false);



 

  
  const [clinicalData,setClinicalData]=useState({})
  const [clinicalOpen,setClinicalOpen]=useState(false);
  const [clinicalViewOpen,setClinicalViewOpen]=useState(false);

  const [viewClinical,setViewClinical]=useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [clinicalNotesData, setClinicalNotesData] = useState([]);
  const [patientIntakeFormData, setPatientIntakeFormData] = useState([]);
  const [id,setId]=useState("")
  const [ehrSync,setEhrSync]=useState(false);
  const [sendEhrLoading,setSendEhrLoading]=useState(false);
  const [ehrId,setEhrId]=useState(0);
 

  const [loading, setLoading] = useState(false);


  const handleClick = () => {
    if (activeTab === '1') {
      setOpenPatientClinicalForm(true);
      return;
    } else if (activeTab === '2') {
      setOpenPatientIntakeForm(true);
      return;
    }
  };

  const getTableData = () => {
    switch (activeTab) {
      case '1':
        return clinicalNotesData; // Empty, as there's no data yet for discharge summary
      case '2':
        return patientIntakeFormData;
     
      default:
        return [];
    }
  };

  const getTableColumns = () => {
    switch (activeTab) {
      case '1':
        return clinicalNotesColumns;
      case '2':
        return patientIntakeColumns;
    
      default:
        return [];
    }
  };

  const getButtonText = () => {
    switch (activeTab) {
      case '1':
        return 'Generate Clinical Notes';
      case '2':
        return 'New Patient Intake Form';
    
      default:
        return 'Generate New';
    }
  };

  useEffect(() => {
    const token =localStorage.getItem("accessToken")
    if (!token) {

      message.error("You are not authorized! please login");
      return;
    }
    
      sessionStorage.removeItem("ehr-data");
      sessionStorage.removeItem("clinical-data");
      sessionStorage.removeItem("form-type");
      fetchClinicalNotesData();
      setLoading(true);
      fetchPatientIntakeData();

  }, [deleted,openPatientClinicalForm,openPatientIntakeForm,ehrSync]);

  const fetchClinicalNotesData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+'/get_clinical_notes/',
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, 
             'ngrok-skip-browser-warning': '1' 
          },
        }

      ); 
      const data = await response.data;
      console.log(data)
      setClinicalNotesData(data);
    } catch (error) {
      if (error?.response?.status == 401) {
        message.error("You are not authorized! please login");
        return
      }
      if (error?.response?.status == 403) {
        message.error("You are not authorized! please verified your email");
        return
      }
      console.log(error)
     
    } finally {
      setLoading(false);
    }
  };
 
  const fetchPatientIntakeData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+'/get_patient_forms/',
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, 
          },
        }
      ); 
      const data = await response.data;
      console.log(data)
      setPatientIntakeFormData(data);
    } catch (error) {
      if (error?.response?.status == 401) {
        message.error("You are not authorized! please login");
        return
      }
      if (error?.response?.status == 403) {
        message.error("You are not authorized! please verified your email");
        return
      }
    } finally {
      setLoading(false);
    }
  };

  const handleViewForm = (file) => {
    const pdfUrl = process.env.REACT_APP_BASE_URL + file;
    window.open(pdfUrl, "_blank");
  };
 
  
  const clinicalNotesColumns = [
   
    {
      title: 'Patient Name',
      dataIndex: 'patient_name',
      key: 'patient_name',
    },
  
    {
      title: 'Date Generated',
      dataIndex: 'created_at',
      key: 'created_at',
    },
   
    {
      title: 'Actions',
      key: 'actions',
      render: (row) => (
        row.status ? 
        <span className="flex space-x-4">
          
          <EyeOutlined  onClick={(e)=>handleEditDataClinicalView(row.id)} className="text-gray-400 cursor-pointer" />
          <EditOutlined  onClick={(e)=>handleEditDataClinical(row.id)}  className="text-gray-400 cursor-pointer" />
          <DeleteOutlined onClick={(e)=>handleDeleteClinical(row.id)} className="text-gray-400 cursor-pointer" />
        </span> :<Button  onClick={(e)=>handleContinue(row.id)}> Continue</Button>
    
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (row) => (
        <span>
         {!row.ehr_status ? <Button loading={sendEhrLoading && ehrId == row.id} onClick={(e)=>handleEhRSync(row.id)}  className='flex items-center' icon={<SyncOutlined className="text-gray-400 cursor-pointer" /> } > EHR Sync</Button>: "EHR Synced" }
        </span>
      ),
    },
  ];
  
  const patientIntakeColumns = [
   
    {
      title: 'Patient Name',
      dataIndex: 'patient_name',
      key: 'patient_name',
    },
    {
      title: 'Patient Email',
      dataIndex: 'patient_email',
      key: 'patient_email',
    },
    {
      title: 'Form Status',
      render: (row) => (
        <span className="flex space-x-2">
          <p>{row.form_status ? 'Submitted' : 'Not Submitted'}</p>
         
        </span>
      ),
      key: 'form_status',
    },
  
  
    {
      title: 'Date Generated',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (row) => (
        <span className="flex space-x-1">
          {row.form_status ? (<EyeOutlined onClick={(e)=>handleViewForm(row.file_url)} onClickclassName="text-gray-400 cursor-pointer" />):"No form exist"}
         
        </span>
      ),
    },
  ];






  
  const handleDeleteClinical = (id) => {
    confirm({
      title: 'Are you sure you want to delete this clinical note?',
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      cancelText: 'Cancel',
      okType: 'danger',
      onOk: async () => {
        try {
          const response = await axios.delete(process.env.REACT_APP_BASE_URL + `/delete_clinical_note/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          });
  
          if (response.status === 200) {
            message.success('Clinical note record deleted successfully');
            setDeleted(!deleted); 
          }
        } catch (error) {
          if (error?.response?.status === 401) {
            message.error('You are not authorized! Please login');
            return;
          }
          if (error?.response?.status === 403) {
            message.error("You are not authorized! please verified your email");
            return
          }
          console.error('Error deleting record:', error);
        }
      },
      onCancel: () => {
        message.info('Deletion canceled');
      },
    });
  };
  



  const handleEditDataClinical = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/get_clinical_note/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (response.status === 200) {
        const data = response.data;
        setClinicalData(data)
        setId(id)
        setClinicalOpen(true);
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        message.error("You are not authorized! please login");
        return
      }
      if (error?.response?.status == 403) {
        message.error("You are not authorized! please verified your email");
        return
      }
      console.error('Error fetching summary:', error);
      return null;
    }
  };

  const handleEditDataClinicalView = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/get_clinical_note/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (response.status === 200) {
        const data = response.data;
        setClinicalData(data)
        setViewClinical(true);
        setClinicalViewOpen(true);
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        message.error("You are not authorized! please login");
        return
      }
      if (error?.response?.status == 403) {
        message.error("You are not authorized! please verified your email");
        return
      }
      console.error('Error fetching summary:', error);
      return null;
    }
  };
  const handleContinue = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/get_clinical_note/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            'ngrok-skip-browser-warning': '1' 
          },
        }
      );
      if (response.status === 200) {
        const data = response.data;
        sessionStorage.setItem("clinical-data", JSON.stringify([data]));
        navigate("/generate-clinical-note");
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        message.error("You are not authorized! please login");
        return
      }
      if (error?.response?.status == 500) {
        message.error("Something went wrong! please try again");
        return
      }
      if (error?.response?.status == 403) {
        message.error("You are not authorized! please verified your email");
        return
      }
      console.error('Error fetching summary:', error);
      return null;
    }
  };


  const handleEhRSync = async (id) => {
    setEhrId(id)
    setSendEhrLoading(true);

    try {
      const response = await axios.post(process.env.REACT_APP_BASE_URL+`/import/`,{
        id:id,
        note_type:"clinical",
      },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (response.status === 200) {
        setSendEhrLoading(false);
        message.success("EHR has been synced");
        setEhrSync(!ehrSync);
      }
    } catch (error) {
      setSendEhrLoading(false);
    
      if (error?.response?.status == 401) {
        message.error("You are not authorized! please login");
        return
      }
      if (error?.response?.status == 403) {
        message.error("You are not authorized! please verified your email");
        return
      }
      if(error?.response?.status == 404){
        message.error("Patient not found in EHR");
        return;
      }
      

      return null;
    }
  };



  return (
    <div className="p-6 border-2 border-gray-100 mt-4 ">
      <h1 className="text-2xl font-bold mb-4 text-center">Generate Clinical Note</h1>
      <div className="flex max-md:flex-col items-center justify-between mb-4 ">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          
          className="max-xl-w-[40%]"
        >
          
          <TabPane tab="Clinical Notes" key="1" />
          <TabPane tab="Patient Intake Form" key="2" />
        </Tabs>
        <Button 
        type="primary"
        className="primary mb-4"
        onClick={handleClick}>
        {getButtonText()}
        </Button>
      </div>

      {loading ? (
        <div className='flex w-full justify-center items-center'>
        <Spin tip="Loading..." />
        </div>
      )  : (
        <Table
          columns={getTableColumns()}
          dataSource={getTableData()}
          pagination={false}
          scroll={{ x: 'max-content' }}
         className='border-l-[1px] border-r-[1px] border-gray-200 overflow-x-auto w-full'
        />
      )}

     
      {openPatientIntakeForm && <PatientIntakeForm openPatientIntakeForm={openPatientIntakeForm} setOpenPatientIntakeForm={setOpenPatientIntakeForm} />}
      {openPatientClinicalForm &&<ClinicalNotePatientForm isOpen={openPatientClinicalForm} setOpenPatientClinicalForm={setOpenPatientClinicalForm} />}

      {clinicalOpen &&<ClinicalNotesModal isOpen={clinicalOpen} onClose={setClinicalOpen} data={clinicalData}  id={id} />}
      {clinicalViewOpen &&<ClinicalNotesModal isOpen={clinicalViewOpen} onClose={setClinicalViewOpen} data={clinicalData} view={viewClinical}  />}

    </div>
  );
}
